export function tabs() {
    let tabsContainer = document.querySelectorAll('[data-tabsContainer]');

    tabsContainer.forEach(container => {
        let tabBtns = container.querySelectorAll('[data-tabBtn]');
        let currentTabEl = container.querySelector('[data-tabBtn]._active');
        let currentTab = "";
        if (currentTabEl) {
            currentTab = currentTabEl.getAttribute('data-tabBtn');
        }

        let tabs = container.querySelectorAll('[data-tabPanel]');

        function closeTabs() {
            tabs.forEach(tab => {
                tab.classList.remove('_active');
            })

            tabBtns.forEach(btn => {
                btn.classList.remove('_active');
            })
        }

        function openTab(targetId, btn) {

            if (currentTab != targetId) {
                closeTabs();
                let tab = container.querySelector(`[data-tabPanel=${targetId}]`);
                currentTab = targetId;
                tab.classList.add('_active');
                btn.classList.add('_active');
            }
        }

        tabBtns.forEach(btn => {
            let targetId = btn.getAttribute('data-tabBtn');
            btn.addEventListener('click', evt => openTab(targetId, btn));
        })

    })
}
